import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item'];

  connect() {
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    });

    this.itemTargets.forEach((el) => {
      if (this.isVisible(el)) {
        el.classList.add('blog-reveal-visible');
      } else {
        el.classList.add('blog-reveal-awaiting');
      }
      this.observer.observe(el);
    });
  }

  isVisible(el) {
    const rect = el.getBoundingClientRect();
    const viewportBottom = window.innerHeight * 0.92;

    return rect.top < viewportBottom && rect.bottom > 0;
  }

  disconnect() {
    this.observer?.disconnect();
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('blog-reveal-visible');
      }
    });
  }
}
